import { render, staticRenderFns } from "./LeaveSettingsStep.vue?vue&type=template&id=27afb988&scoped=true"
import script from "./LeaveSettingsStep.vue?vue&type=script&lang=js"
export * from "./LeaveSettingsStep.vue?vue&type=script&lang=js"
import style0 from "./LeaveSettingsStep.vue?vue&type=style&index=0&id=27afb988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27afb988",
  null
  
)

export default component.exports